import React, { createContext, useContext, useState, useCallback } from "react";

const FORMATS = [
  { id: "auto", label: "Auto", hint: "Each synced league valued by its own format" },
  { id: "1qb", label: "1QB", hint: "Force standard single-QB" },
  { id: "superflex", label: "Superflex", hint: "Force Superflex — QBs worth more" },
  { id: "tep", label: "TE Premium", hint: "Force TE Premium — TEs worth more" },
];

const FormatContext = createContext(null);

export function FormatProvider({ children }) {
  const [format, setFormatState] = useState(localStorage.getItem("de_format") || "auto");
  // When viewing a single synced league, that page reports the format Auto resolves to,
  // so the toggle can show "Auto · SF" instead of a bare "Auto".
  const [resolvedFormat, setResolvedFormat] = useState(null);
  const setFormat = useCallback((f) => {
    localStorage.setItem("de_format", f);
    setFormatState(f);
  }, []);
  return (
    <FormatContext.Provider value={{ format, setFormat, formats: FORMATS, resolvedFormat, setResolvedFormat }}>
      {children}
    </FormatContext.Provider>
  );
}

export function useFormat() {
  const ctx = useContext(FormatContext);
  if (!ctx) return { format: "auto", setFormat: () => {}, formats: FORMATS, resolvedFormat: null, setResolvedFormat: () => {} };
  return ctx;
}

export { FORMATS };
